import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M14.405 7.345a.75.75 0 010 1.06l-8.25 8.25a.75.75 0 01-1.06 0L.97 12.53a.75.75 0 111.06-1.06l3.595 3.594 7.72-7.72a.75.75 0 011.06 0zM23.03 7.345a.75.75 0 010 1.06l-8.25 8.25a.75.75 0 01-1.06 0l-2.194-2.193a.75.75 0 011.06-1.061l1.664 1.663 7.72-7.72a.75.75 0 011.06 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
